import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import '../css/Home.css';

import { Icon,PagingButton,ConfigBox } from 'component-lib';
import PanelsLinks from "../custom_controls/PanelsLinks";

import { RequestAjaxClass, ContractsModel, UserConfigurationModel } from 'models-lib';

class Home  extends Component {

    //#region panels auf Seitenbreite anpassen
    constructor(props)
    {
        super(props);
        this.state ={};
        this.AllPanels = '';//alle die möglich sind
        this.schownPanels = '';//die die angezeigt werden
        this.Count = 0;
        this.messen = this.messen.bind(this);
        this._isMounted = false;
        this.state.ConfigMode = false;
        this.state.change = false;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.ContractsModel = new ContractsModel([this]);
        this.UserConfigurationModel =  new UserConfigurationModel([this]);

        localStorage.removeItem('csvDataContent');
    }

    componentWillMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.ContractsModel.SetRequest(this.Request);
        this.UserConfigurationModel.SetRequest(this.Request);

        this.ContractsModel.GetContracts(null,0,100,null,null,10);

        let me = this;
        window.onpopstate = function(event){
            let schownPanels = [[],[]];
            if (localStorage.getItem('vas_config')){
                if (localStorage.getItem("vas_config").length > 0){
                    schownPanels = JSON.parse(localStorage.getItem("vas_config"));
                }
            }
            for (let i = 0; i< schownPanels.length; i++){
                if (me.refs[schownPanels[i][0]]){
                    me.refs[schownPanels[i][0]].setState({ open:schownPanels[i][1] }); 
                }
            }
        };
       
        let schownPanels = [[],[]];
        if (localStorage.getItem('vas_config')){
           if (localStorage.getItem("vas_config").length > 0){
                schownPanels = JSON.parse(localStorage.getItem("vas_config"));
            } 
        }
        
        this.setState({ Configuration:schownPanels[0],NotShowen: schownPanels[1] });
    }

    componentDidMount(){
        this.mount();
        this._isMounted = true;
        window.addEventListener("resize",this.messen);
        let me = this;
        try {
            let schownPanels = this.state.Configuration;
            if (schownPanels){
            
                for (let i = 0; i< schownPanels.length; i++){
                    if (me.refs[schownPanels[i][0]]){
                        
                        me.refs[schownPanels[i][0]].setState({ open:schownPanels[i][1], oldValues: schownPanels });
                    }
                }
            }
        }
        catch (err){
            
        }        
    }
          
    componentDidUpdate(e){
        
        //für drag&drop
          this.mount();
         //Panels nach Spaltenänderung richtig anordnen und auf/zu klappen
         let elms = document.querySelectorAll('.zielzone');
         for (let i = 0; i < elms.length; i++) {
             $("#"+elms[i].id).hide().show();
         };
         let me = this;    
         let schownPanels = this.state.Configuration;
        
         for (let i = 0; i< schownPanels.length; i++){
             if (me.refs[schownPanels[i][0]]){
                 me.refs[schownPanels[i][0]].setState({ open:schownPanels[i][1], oldValues: schownPanels }); 
             }
         }
     }
     
     componentWillUnmount(){
         this._isMounted = false;
         localStorage.setItem("vas_config",JSON.stringify([this.state.Configuration,this.state.NotShowen]));
         window.removeEventListener("resize",this.messen.bind(this));
     }
     
    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Contracts"){
                me.setState({ ContractsCeckCount : this.ContractsModel.Count });
            }
        })
    }
     messen(){
        if (this._isMounted === true){
            let panelWidth = 320;
            let width = window.innerWidth;

            let count = Math.floor(width/panelWidth);
            
            if ((count + 1 === this.Count)||(count - 1 === this.Count)){
                this.Count = count;
                if (this){
                    this.setState({ Count:count });
                }
            } else {
                this.Count = count; 
            }
        }
    }

    arrangeItems(rowArr){
        
        let rowlines = ''; 
        let i = 0;
        // eslint-disable-next-line
        rowlines = rowArr.map(r =>{
            if (r.length > 0){
                i++;
                return (
                  <tr key={i} >
                    {r.map(c =>{
                            i++;
                            return (
                              <td key={i}>
                                <div 
                                  id={Math.round(Math.random() * (100 - 1)) + 1} 
                                  className={"zielzone"}>{c}
                                </div>
                              </td> 
                            );
                        })}
                  </tr>
                );
            }
        });

        return ( rowlines);
    }

    //#endregion
    
    //#region Komponente
    
    //für drag&drop

    mount(){
      let me = this;
        let elms = document.querySelectorAll(".zielzone");
        for (let i = 0; i < elms.length; i++) {
            let zielzone = elms[i];
            zielzone.addEventListener("drop",me.drop);
            zielzone.addEventListener("dragover",me.dragOver);
            zielzone.addEventListener('dragenter', me.dragEnter, false);
        };
    
        elms = document.querySelectorAll("[draggable=true]");
        
        for (let i = 0; i < elms.length; i++) {
            let draggable = elms[i];
            draggable.addEventListener("dragstart",me.drag);
        }
    }
    //#endregion

    //#region drag&drop

    drag = (event) => {
        event.dataTransfer.setData('text', event.target.id);
    }
    
    dragOver(event) {
        event.preventDefault();
    }
 
    drop = (event) =>{
            
        event.preventDefault();
        let target = event.target;  // ziel des ziehenden divs
        
        if ((event.target.className === "panelContent")||(event.target.className === "panelHeader")||(event.target.className === "link")||(event.target.className === "copen")||
        (event.target.tagName === 'IMG')||(event.target.tagName === 'TD')||(event.target.className === 'border'))
        {
            let elms = document.querySelectorAll(".zielzone");
            for (let i = 0; i < elms.length; i++) {
                if (elms[i].contains(event.target)){
                    target = elms[i];
                }
            }
        }
    
        let data = event.dataTransfer.getData('text'); // das ziehende div
        
        if (document.getElementById(data)){
            
            let quelle = document.getElementById(data).parentElement; //wo das ziehende div herkommt
            
            let oldPlace = quelle.children[0].id;
            let newPlace = target.children[0].id;
            let oldId = '';
            let newId = '';
            for (let i = 0; i< this.state.Configuration.length; i++){
                if (newPlace === this.state.Configuration[i][0]){
                    newId = i;
                }
            }
            for (let i = 0; i< this.state.Configuration.length; i++){
                if (oldPlace === this.state.Configuration[i][0]){
                    oldId = i;
                }
            }
            if (newId !== oldId){
                let newValues = this.move(this.state.Configuration,oldId,newId);
                if (this){
                    this.setState({ newValues:newValues });
                }
                this.Save();
            }
        }
        this.dragLeave();
    }

    move(arr, old_index, new_index) { //https://www.w3resource.com/javascript-exercises/javascript-array-exercise-38.php 27.08.2018
        while (old_index < 0) {
            old_index += arr.length;
        }
        while (new_index < 0) {
            new_index += arr.length;
        }
        if (new_index >= arr.length) {
            let k = new_index - arr.length;
            while ((k--) + 1) {
                arr.push(undefined);
            }
        }
        
         arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);  
       return arr;
    }

    dragEnter(){
        let elms = document.querySelectorAll(".zielzone");
        for (let i = 0; i < elms.length; i++) {
            let zielzone = elms[i];
            zielzone.classList.add('over');
        };
    }
      
    dragLeave(){
        let elms = document.querySelectorAll(".zielzone");
        for (let i = 0; i < elms.length; i++) {
            let zielzone = elms[i];
            zielzone.classList.remove('over');
        };
    }
    //#endregion

    Save(){
        let newValues = this.state.newValues;
        let context = this.AllPanels;
        let notVisible = [];
        for (let i=0; i< context.length; i++){
            let visible = false;
            for (let j = 0; j< newValues.length; j++){
                if (context[i] !== undefined){
                    if (context[i].props.Id === newValues[j][0]){
                        visible = true;
                    }
                }
            }
            if ( visible === false){
                if (context[i] !== undefined){
                    notVisible.push(context[i].props.Id);
                }
            }
        }
        
        if (newValues){
            let sendData={};
            sendData.Configuration = JSON.stringify([newValues,notVisible]);
                        
            this.UserConfigurationModel.SetUserConfiguration([newValues,notVisible]);
            this.setState({Configuration:newValues});
        }
    }

    Config(){
        ReactDOM.render(<ConfigBox 
          AppURL={Vas.ApplicationUrl} 
          LabelPanelsShow={Vas.Resources.Labels["PanelsShow"]} 
          Context={this.AllPanels} 
          Panels={this.schownPanels} 
          Reference={this} /> 
            , document.getElementById('popupContainer'));
    }

    Refresh(newPanels){
        
        let oldPanels = this.state.Configuration;
        
        let panels = [];
        for (let i = 0; i< oldPanels.length; i++){
            for (let j = 0; j< newPanels.length; j++){
                if (oldPanels[i][0] === newPanels[j][0]){
                    panels.push(oldPanels[i]);
                }
            }
        }
        for (let i = 0; i< newPanels.length; i++){
            let found = false;
            for (let j = 0; j< oldPanels.length; j++){
                if (oldPanels[j][0] === newPanels[i][0]){
                    found = true;
                }
            }
            if (found === false){
                panels.push(newPanels[i]);
            }
        }
        
        let context = this.AllPanels;
        let notVisible = [];
        for (let i=0; i< context.length; i++){
            let visible = false;
            for (let j = 0; j< panels.length; j++){
                if (context[i] !== undefined){
                    if (context[i].props.Id === panels[j][0]){
                        visible = true;
                    }
                }
                
            }
            if ( visible === false){
                if (context[i] !== undefined){
                    notVisible.push(context[i].props.Id);
                }
            }
        }
        
        let sendData={};
        sendData.Configuration = JSON.stringify([panels,notVisible]);
       
        this.UserConfigurationModel.SetUserConfiguration([panels,notVisible]);
        this.setState({Configuration:panels,NotShowen:notVisible});
    }

    render() {

        let arr = PanelsLinks.HomePanels(this,this.state.ContractsCeckCount);
        let AllPanels = [];
        arr.forEach(e => {
            if (e !== ""){
                AllPanels.push(e);
            }
        });

        let schownPanels = [];
        try {
            schownPanels = this.state.Configuration;
        }
        catch (err){
            for (let i = 0; i< AllPanels.length; i++){
                schownPanels.push([AllPanels[i].ref,true]);
            }
        } 

        if (schownPanels.length !== 0){
            if (Array.isArray(schownPanels) === false){
                schownPanels = [];
                for (let i = 0; i< AllPanels.length; i++){
                    schownPanels.push([AllPanels[i].ref,true]);
                }
            }
        }
               
        //#region neue Panels hinzufügen

        let all = AllPanels;
        let extraPanels = [];//für das Hinzufügen von Neuen Panels, die noch nicht in der Configuration gespeichert sind
        for (let i =0; i< all.length; i++){
            if (all[i] !== undefined){
                extraPanels.push(all[i].props.Id);
            }
        }

        for (let i = 0; i< schownPanels.length; i++){
            let idx = extraPanels.indexOf(schownPanels[i][0]);
            if (idx >= 0){
                extraPanels.splice(idx,1);
            }
        }

        let notShowenPanels = this.state.NotShowen;
        for (let i = 0; i< notShowenPanels.length; i++){
            let idx = extraPanels.indexOf(notShowenPanels[i]);
            if (idx >= 0){
                extraPanels.splice(idx,1);
            }
        }
        
        if (extraPanels.length > 0){
            for (let i = 0; i< extraPanels.length; i++){
                schownPanels.push([extraPanels[i],true]);
            }
        }
        //endregion

        //Werte für Konfigurations Popup
        this.schownPanels = schownPanels; 
        this.AllPanels = AllPanels;

        localStorage.setItem('links',JSON.stringify(schownPanels));
        
        let anzahl = 3;
        if (this.state.Count){
            anzahl = this.state.Count;
        }
        let rows = '';
        rows = Math.ceil(schownPanels.length/anzahl);

        let rowArr = new Array(rows);
               
        for (let j = 0 ; j < rows; j++)
        {
            rowArr[j] = new Array(anzahl);
        }
        //rowArr -> vorbereitetes Array mit fertigen Zeilen und Spalten aber ohne Inhalt
        //schownPanels -> Panels die angezeigt werden mit [ID, open]
        //AllPanels -> alle möglichen Panels als Panel-Object
        let rowId = 0;
        let colId = 0;
        for (let i = 0; i< schownPanels.length; i++){
            let id = schownPanels[i][0];                          //anzuzeigendes Panel
            for (let j = 0; j< AllPanels.length; j++){
                if (AllPanels[j] !== undefined){
                    if (AllPanels[j].ref === id){                  //anzuzeigendes Panel ist in den möglichen Panels vorhanden
                        let obj = AllPanels[j];                  
                        for (let k = 0; k< rowArr.length; k++){
                            if (rowArr[k].indexOf(obj) < 0){     //anzuzeigendes Panel wird noch nicht angezeigt
                                rowArr[rowId][colId] = obj;     // Panel wird hinzugefügt
                                colId++;                        
                                if (colId === anzahl){
                                    colId = 0;
                                    rowId++;
                                    if (rowId >= rows){
                                        break;
                                    }
                                }
                            } else {
                                break;
                            }
                            break;
                        }
                    }
                }
            }
        }
    //#endregion    
    return (
      <div>
        <table id={"homeTable"}>
          <tbody>
            {this.arrangeItems(rowArr)}
            <tr>
              <td><PagingButton 
                ref={"Configuration2"} 
                text={<Icon  
                  Name={"Administration"} 
                  Size={24}
                  Color={"white"} 
                  PaddingLeft={'6px'} 
                  PaddingTop={'6px'} />} 
                onClick={()=>{this.Config();}} 
                Type={"Picker"} 
                Width={40} 
                Id={"btoOrder"} /> </td>
            </tr>
          </tbody>
        </table>
      </div>);
    }
}
export default Home;
